import type { TMemberDTO, TMemberVisibilityDTO } from './members.dto';

import type { TMember, TMemberVisibility } from './members.types';

const toMember = (dto: TMemberDTO): TMember => ({
  id: dto.id,
  firstName: dto.first_name ?? '',
  lastName: dto.last_name ?? '',
  role: dto.role,
  status: dto.status,
  birthDate: dto.birth_date,
  city: dto.city,
  marketID: dto.market_id,
  conciergeID: dto.assigned_concierge_id,
  isAmbassador: dto.is_ambassador,
  archivedAt: dto.archived_at,
  activatedAt: dto.activated_at,
  lastTouchAt: dto.last_touch_at,
  paymentStatus: dto.clients?.payment_status ?? null,
  isComped: dto.clients?.is_comped ?? false,
});

const toMemberVisibility = (dto: TMemberVisibilityDTO): TMemberVisibility => ({
  memberID: dto.id,
  isVisible: dto.member_visible ?? false,
});

export {
  toMember,
  toMemberVisibility,
};
